import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export const fetchEarningsListReducer = createAsyncThunk(
  "earnings/fetchList",
  async (params = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);
      if (params.paymentStatus) queryParams.append("paymentStatus", params.paymentStatus);
      if (params.date) queryParams.append("date", params.date);
      if (params.serviceName) queryParams.append("serviceName", params.serviceName);

      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.physioEarningsList}?${queryParams.toString()}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || "Failed to fetch earnings list.";
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching earnings list:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching earnings list.";
      return rejectWithValue(errMsg);
    }
  }
);
